import { useMount } from 'ahooks';

import { setVipKefuFlag } from '@/api/hall';
import { implog } from '@/api/implog';
// import ServiceBg from '@/assets/modal/kefu_bg.webp';
import BlurryLoadingImage from '@/components/progressive-img';
import { ACCESS_USERID_KEY } from '@/constant/config';
import Storage from '@/utils/Storage';
import { openKefu } from '@/utils/utils';

import styles from './styles.module.less';

const KefuModal = (modal, onClose) => {
  useMount(async () => {
    implog('kefu_modal_show');
  });

  return (
    <div className={styles.main}>
      <BlurryLoadingImage loading="lazy" src={(window?.imgPrefix || '') + '/img/kefu/kefu_bg.webp'} />
      <div
        className={styles.btn}
        onClick={async () => {
          implog('kefu_modal_click');
          const userId = Storage.getAccess(ACCESS_USERID_KEY);
          Storage.set('IS_KEFU_OEPNED_' + userId, true);
          setVipKefuFlag();
          openKefu();
          onClose?.();
        }}
      ></div>
    </div>
  );
};

export default KefuModal;
